"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";
import { MapPin, CreditCard, QrCode } from "lucide-react";

/**
 * Travel Connected — homepage "How it Works" band per
 * generated_homepage_or_landing.png: a light commercial panel with 3 numbered
 * steps (Choose destination / Pay & get eSIM / Scan & activate). Server/static.
 */
export default function StepsPreview() {
  const { t } = useTranslations();

  const steps = [
    {
      n: "1", icon: MapPin,
      title: t("pc.steps.s1", "Choose your destination"),
      body: t("pc.steps.s1b", "Select a country or region for your travel."),
    },
    {
      n: "2", icon: CreditCard,
      title: t("pc.steps.s2", "Pay & get your eSIM"),
      body: t("pc.steps.s2b", "Secure checkout and receive your eSIM by email instantly."),
    },
    {
      n: "3", icon: QrCode,
      title: t("pc.steps.s3", "Scan & activate"),
      body: t("pc.steps.s3b", "Scan the QR code in your settings to connect. No physical SIM needed."),
    },
  ];

  return (
    <section className="container mx-auto px-4 py-6">
      <Reveal as="div" className="rounded-2xl bg-muted/50 border border-border p-6 sm:p-8" y={20}>
        <h2 className="text-center text-2xl sm:text-3xl text-foreground mb-8">{t("pc.steps.title", "How it works")}</h2>
        <Stagger as="div" className="grid md:grid-cols-3 gap-6" staggerChildren={0.1} amount={0.3}>
          {steps.map(({ n, icon: Icon, title, body }) => (
            <StaggerItem as="div" key={n} y={16} className="flex items-start gap-4">
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-card border border-border text-primary shrink-0">
                <Icon className="w-6 h-6" />
              </span>
              <div>
                <div className="inline-flex items-center gap-2">
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-primary text-primary-foreground text-xs font-bold">{n}</span>
                  <h3 className="font-bold text-foreground">{title}</h3>
                </div>
                <p className="mt-1 text-sm text-muted-foreground">{body}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </Reveal>
    </section>
  );
}
